import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Briefs } from "../components/site/Briefs";
import { Process } from "../components/site/Process";
import { Timeline } from "../components/site/Timeline";
import { Gateways } from "../components/site/Gateways";
import { Footer } from "../components/site/Footer";
import { TextMarquee } from "../components/site/TextMarquee";
import { PullQuote } from "../components/site/PullQuote";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#0a0a0a]">
      <Nav />
      <main>
        <Hero />
        <TextMarquee items={["Sports", "Events", "Experiences", "Sport", "Scale", "Impact"]} />
        <About />
        <Briefs />
        <Process />
        <Timeline />
        <PullQuote
          quote="The people you meet while discussing the work tend to be the people you meet while doing the work."
        />
        <Gateways />
        <Footer />
      </main>
    </div>
  );
}
